import React, {Component} from "react";
import Chart from "react-apexcharts";

class PlanningChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            series: [{
                name: 'label.carryWork',
                data: [44]
            }, {
                name: 'Striking Calf',
                data: [53]
            }, {
                name: 'Tank Picture',
                data: [12]
            }, {
                name: 'Bucket Slope',
                data: [9]
            },],
            options: {
                xaxis: {
                    show: false
                },
                yaxis: {
                    show: false,
                },
                chart: {
                    type: 'bar',
                    height: 100,
                    stacked: true,
                    stackType: '100%',
                    toolbar: {
                        show: false
                    }
                },
                legend: {
                    show: false
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                    },
                },
                tooltip: {
                    enabled: false,

                },
                fill: {
                    opacity: 1
                },
            },
        };
    }
    render() {
        return (
            <div className="app">
                <div className="row">
                    <div className="mixed-chart">
                        <Chart
                            options={this.state.options}
                            series={this.state.series}
                            type="bar"
                            height="150px"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default PlanningChart;
